export default {
  GetLoginAdm ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($email: String, $senha: String) {
            LoginAdm (email: $email, senha: $senha) {
              status,
              message,
              user {
                nome,
                email,
                token
              }
            }
          }
        `,
        variables: {
          email: payload.email,
          senha: payload.senha
        }
      })
      .then(res => {
        if (res.data.data.LoginAdm.status) {
          this.$http.defaults.headers.common.token = res.data.data.LoginAdm.user.token
          commit('GET_LOGIN_ADM', res.data.data.LoginAdm.user)
        }
        resolve(res.data.data.LoginAdm)
      }) 
    }) 
  },
  GetSubscriptions ({ dispatch }) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          {
            GetSubscriptions {
              id,
              name,
              email,
              status,
              trail_start,
              trail_end
            }
          }
        `
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data.GetSubscriptions)
      }) 
    }) 
  },
  ListItemSelectedPush ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('LIST_ITEM_SELECTED_PUSH', payload)
      resolve()
    })
  },
  ListItemSelectedDel ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('LIST_ITEM_SELECTED_DEL', payload)
      resolve()
    })
  },
  GetSubscriptionEmail ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          query ($email: String) {
            GetSubscriptionEmail (email: $email) {
              id,
              name,
              email,
              status,
              trail_start,
              trail_end
            }
          }
        `,
        variables: {
          email: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data.GetSubscriptionEmail)
      }) 
    }) 
  },
  GetContas ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          query ($email: String) {
            GetContas (email: $email) {
              id,
              nome_empresa,
              subdominio,
              modelo,
              email,
              status,
              ativo,
              log,
              statusLog
            }
          }
        `,
        variables: {
          email: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data.GetContas)
      }) 
    }) 
  },
  _UpdateContas ({ dispatch, getters, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($contas: [icontas], $ativo: Boolean) {
            _UpdateContas (contas: $contas, ativo: $ativo)
          }
        `,
        variables: {
          contas: getters.listItemSelected,
          ativo: payload
        }
      })
      .then(() => {
        commit('UPDATE_CONTAS', payload)
        dispatch('Loading', false)
        resolve()
      }) 
    }) 
  },
  _UpdateContasLog ({ dispatch, getters, commit }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($contas: [icontas], $log: Boolean) {
            _UpdateContasLog (contas: $contas, log: $log)
          }
        `,
        variables: {
          contas: getters.listItemSelected,
          log: payload
        }
      })
      .then(() => {
        commit('UPDATE_CONTAS_LOG', payload)
        dispatch('Loading', false)
        resolve()
      }) 
    }) 
  },
  _CreateBlacklist ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: iblacklist) {
            _CreateBlacklist (payload: $payload) {
              id,
              text
            }
          }
        `,
        variables: {
          payload: { text: payload }
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      }) 
    }) 
  },
  GetBlacklist ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          query ($payload: String) {
            GetBlacklist (text: $payload) {
              id,
              text
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        resolve(res.data.data.GetBlacklist)
      }) 
    }) 
  },
  _DeleteBlacklist ({ dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: [iblacklist]) {
            _DeleteBlacklist (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(() => {
        dispatch('Loading', false)
        resolve()
      }) 
    }) 
  }
}
